import { jsx as e } from "react/jsx-runtime";
const i = (l) => e("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1.5em", height: "1.5em", fill: "currentColor", viewBox: "0 0 24 24", focusable: "false", "aria-hidden": "true" }, l, { children: e("path", { fill: "inherit", d: "M3.99 21 3 20.01l6.59-6.589H4.895V12H12v7.105h-1.421V14.41zM12 12V4.895h1.421V9.59L20.011 3l.989.99-6.59 6.589h4.695V12z" }) }));
export {
  i as default
};
